<!-- 个人信息 -->
<template>
    <div
        v-visually="{
            serverId: 17080,
            area: 'personal-info',
        }"
        class="info-page"
    >
        <!-- 二级菜单 -->
        <div class="info-tabs">
            <div
                v-for="item in tabArr"
                :key="item.key"
                class="info-tab"
                :class="{active: curSubTab === item.key}"
                @click="tabChange(item)"
            >
                {{ item.name }}
            </div>
        </div>
        <div ref="scrollView" class="scroll-box">
            <div class="info-wrap">
                <!-- 认证信息部分 -->
                <div id="auth" class="info auth-info">
                    <div class="title">
                        <h3 class="title-name">认证信息</h3>
                        <div :class="['status-text', statusType.value]">{{ statusType.label }}</div>
                        <div
                            class="modify-btn"
                            @click="pageChange('material', {isEdit: 'edit'}, 'authentication-modify-btn')"
                        >
                            修改
                        </div>
                    </div>
                    <div class="info-content">
                        <div class="item">
                            <div class="label">律师头像</div>
                            <div class="value avatar">
                                <img
                                    :src="lawyerInfo.personal_avatar"
                                    alt=""
                                >
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">律师姓名</div>
                            <div class="value">{{ lawyerInfo.name }}</div>
                        </div>
                        <div class="item">
                            <div class="label">身份证号</div>
                            <div class="value">{{ passInfo.cert_code }}</div>
                        </div>
                        <div class="item">
                            <div class="label">执业证号</div>
                            <div class="value">{{ lawyerInfo.register_id }}</div>
                        </div>
                        <div class="item">
                            <div class="label">执业年限</div>
                            <div class="value">{{ lawyerInfo.register_years }}</div>
                        </div>
                        <div class="item">
                            <div class="label">执业律所</div>
                            <div class="value">{{ lawyerInfo.register_law_firm }}</div>
                        </div>
                        <div class="item">
                            <div class="label">执业理念</div>
                            <div
                                class="value"
                                :class="{'isNull': !lawyerInfo.register_philosophy}"
                            >{{ lawyerInfo.register_philosophy || '未填写' }}</div>
                            <div v-if="!lawyerInfo.register_philosophy" class="tips">
                                请填写此信息以完善个人主页提升用户咨询率，<span
                                    class="btn"
                                    @click="pageChange('material', {isEdit: 'edit'}, 'idea-modify-btn')"
                                >点击完善</span>
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">毕业院校</div>
                            <div class="value">{{ lawyerInfo.graduated_school }}</div>
                        </div>
                        <div class="item">
                            <div class="label">个人简介</div>
                            <div class="value">{{ lawyerInfo.personal_intro }}</div>
                        </div>
                        <div class="item">
                            <div class="label">荣誉头衔</div>
                            <div class="value" :class="{'isNull': !lawyerInfo.honorary_title}">
                                {{ lawyerInfo.honorary_title || '未填写' }}
                            </div>
                        </div>
                        <div v-if="lawyerInfo.honorary_licence" class="item">
                            <div class="label">荣誉证书</div>
                            <div class="value">
                                <img
                                    v-for="(item, index) in lawyerInfo.honorary_licence.split('$')"
                                    :key="index"
                                    :src="item"
                                >
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 其他信息部分 -->
                <div id="other" class="info other-info">
                    <div class="line"></div>
                    <div class="title">
                        <h3 class="title-name">其他信息</h3>
                        <div class="modify-btn" @click="pageChange('material', {isEdit: 'edit'}, 'other-modify-btn')">
                            修改
                        </div>
                    </div>
                    <div class="info-content">
                        <div class="item">
                            <div class="label">执业手机</div>
                            <div class="value">{{ lawyerInfo.mobile_number }}</div>
                        </div>
                        <div class="item">
                            <div class="label">律师职务</div>
                            <div class="value">{{ lawyerInfo.lawyer_position }}</div>
                        </div>
                        <div class="item">
                            <div class="label">从业地区</div>
                            <div class="value">{{ lawyerInfo.city }}</div>
                        </div>
                        <div
                            v-if="lawyerInfo.register_domain && lawyerInfo.register_domain.length"
                            class="item"
                        >
                            <div class="label">擅长领域</div>
                            <div class="value domain">
                                <div
                                    v-for="item in lawyerInfo.register_domain.split('$')"
                                    :key="item"
                                    class="domain-item"
                                >
                                    {{ item }}
                                </div>
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">办公地点</div>
                            <div class="value" :class="{'isNull': !lawyerInfo.office_address}">
                                {{ lawyerInfo.office_address || '未填写' }}
                            </div>
                        </div>
                    </div>
                </div>
                <template>
                    <!-- 品宣图配置 -->
                    <div
                        id="pic"
                        class="info"
                    >
                        <div class="line"></div>
                        <div class="title">
                            <h3 class="title-name">PC主页品宣图配置</h3>
                            <div class="modify-btn" @click="modifyBanner">修改</div>
                        </div>
                        <banner-card
                            :lawyer-info="lawyerInfo"
                            :is-show-idea="lawyerInfo.appearance_config
                                && +lawyerInfo.appearance_config.description === 2"
                        />
                    </div>
                    <!-- 亲办案件 -->
                    <div
                        v-if="caseList && caseList.length"
                        id="case"
                        class="info"
                    >
                        <div class="line"></div>
                        <div class="title">
                            <h3 class="title-name">亲办案件(共{{ caseCount }}条)</h3>
                            <div class="modify-btn" @click="pageChange('caseManage', {}, 'case-modify-btn')">修改</div>
                        </div>
                        <div class="case-box real">
                            <case-card
                                v-for="(item, index) in caseList"
                                :key="index"
                                :case-info="item"
                            />
                        </div>
                    </div>
                </template>
                <!-- 百家号信息 -->
                <div
                    v-if="!isNotRegisterdBjh"
                    id="bjh"
                    class="info bjh-info"
                >
                    <div class="line"></div>
                    <div class="title">
                        <h3 class="title-name">百家号信息</h3>
                        <div class="modify-btn" @click="pageChange('bjhRegister', {}, 'bjh-modify-btn')">修改</div>
                    </div>
                    <div class="info-content">
                        <div class="item">
                            <div class="label">百家号头像</div>
                            <div class="value">
                                <img :src="bjhInfo.bjh_info.avatar">
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">百家号昵称</div>
                            <div class="value">{{ bjhInfo.bjh_info.name || '未填写' }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <modify-banner-dialog
            v-if="isShowBannerDialog"
            :lawyer-info="lawyerInfo"
            @submit="updateBanner"
            @close="isShowBannerDialog = false"
        />
    </div>
</template>

<script>
import {mapState} from 'vuex';
import {TAB_ARR, CASE_ARR, STATUS_MAP} from '../config/index';
import bannerCard from '../components/banner-card.vue';
import modifyBannerDialog from '../components/modify-banner-dialog.vue';
import caseCard from '../components/case-card.vue';
import authorizeBtns from '../components/authorize-btns.vue';

export default {
    name: 'info',
    data() {
        return {
            curSubTab: 'auth',
            scrollTopVal: [],
            tabArr: TAB_ARR,
            isShowBannerDialog: false,
            // 案例列表
            caseList: [],
            caseCount: 0,
            caseArr: CASE_ARR
        };
    },
    components: {
        'banner-card': bannerCard,
        'modify-banner-dialog': modifyBannerDialog,
        'case-card': caseCard,
        'authorize-btns': authorizeBtns
    },
    async mounted() {
        await this.getCaseList();
        this.$nextTick(() => {
            this.calcDomTop();
        });
        this.onscrollListener();
    },
    computed: {
        ...mapState({
            bjhInfo: state => state.lawStore.bjhInfo || {},
            vipInfo: state => state.lawStore.vipInfo || {},
            lawyerInfo: state => state.lawStore.userInfoNew.lawyer_info || {},
            passInfo: state => state.lawStore.userInfoNew.pass_info || {}
        }),
        statusType() {
            const {info_status} = this.lawyerInfo;
            return STATUS_MAP[info_status] || '';
        },
        isNotRegisterdBjh() {
            return +this.bjhInfo.bjh_registerd_status === 0 || this.bjhInfo.bjh_info?.status === 'unpass';
        }
    },
    watch: {
        caseList(val) {
            if (!val || !val.length) {
                this.deleteItemInObjArr(this.tabArr, 'case');
            }
        },
        isNotRegisterdBjh: {
            handler(val) {
                if (val) {
                    this.deleteItemInObjArr(this.tabArr, 'bjh');
                }
            },
            immediate: true
        }
    },
    methods: {

        /**
         * 切换 tab 时
         * @param {Object} val 选中的 tab 数据对象
         */

        tabChange(val) {
            let index = this.tabArr.findIndex(item => item.key === val.key);
            index = index === -1 ? 0 : index;
            // tab 点击曝光
            this.$wywLog.send({
                serverId: 17080,
                action: 'click',
                area: val.logArea
            });
            this.$refs.scrollView && this.$refs.scrollView.scrollTo({
                top: this.scrollTopVal[index],
                behavior: 'smooth'
            });
            // 防止滑动还未结束，切换的选中值又被滑动修改
            let timeout = setTimeout(() => {
                this.curSubTab = val.key;
                clearTimeout(timeout);
                timeout = null;
            }, 700);
        },

        /**
         * 切换页面
         * @param {String} route 路由名称
         * @param {Object} query 路由参数
         * @param {String} logArea 打点 area
         */

        pageChange(route, query, logArea) {
            this.$wywLog.send({
                serverId: 17080,
                action: 'click',
                area: logArea
            });
            this.$router.push({
                name: route,
                query
            });
        },
        // 获取每个模块距离父级的顶部距离
        calcDomTop() {
            this.scrollTopVal = [];
            this.tabArr.forEach((item, index) => {
                let top = document.getElementById(item.key)?.offsetTop || 0;
                if (index) {
                    top += 30;
                }
                this.scrollTopVal.push(top);
            });
        },
        // 滑动监听，控制滑动时选中对应的 tab 菜单
        onscrollListener() {
            if (!this.$refs.scrollView) {
                return;
            }
            this.$refs.scrollView.onscroll = event => {
                let scrollTop = event.target.scrollTop;
                for (let i = 0; i < this.scrollTopVal.length; i++) {
                    // 最后一个值
                    if (i === this.scrollTopVal.length - 1) {
                        this.curSubTab = this.tabArr[i].key;
                        break;
                    }
                    else if (scrollTop >= this.scrollTopVal[i] && scrollTop < this.scrollTopVal[i + 1]) {
                        this.curSubTab = this.tabArr[i].key;
                        break;
                    }
                }
            };
        },
        modifyBanner() {
            this.isShowBannerDialog = true;
            this.$wywLog.send({
                serverId: 17080,
                action: 'click',
                area: 'banner-modify-btn'
            });
        },
        updateBanner(data = {}) {
            this.$emit('updateBanner', data);
            this.isShowBannerDialog = false;
        },
        // 获取案例列表
        getCaseList() {
            return this.$http.get('/bp/case/getlawyercaselist', {
                params: {
                    show: 1,
                    pn: 1,
                    rn: 3
                }
            }).then(res => {
                if (!res || +res.code !== 0) {
                    this.caseList = [];
                    return Promise.resolve();
                }
                const data = res?.data || {};
                let {list = [], count} = data;
                this.caseList = list;
                this.caseCount = count;
                return Promise.resolve();
            }).catch(err => {
                this.caseList = [];
                return Promise.resolve();
            });
        },

        /**
         * 删除数组对象中的指定对象
         * @param {Array} arr
         * @param {String} key
         */

        deleteItemInObjArr(arr, key) {
            let index = arr.findIndex(item => item.key === key);
            if (index !== -1) {
                arr.splice(index, 1);
            }
        }
    }
};
</script>

<style lang='less' scoped>
.info-page {
    height: 100%;

    .scroll-box {
        overflow: scroll;
        height: calc(100% - 64px);
        padding-right: 240px;

        .info-wrap {
            position: relative;
        }
    }

    .info-tabs {
        display: flex;
        margin-top: 24px;
        padding-bottom: 30px;

        .info-tab {
            height: 34px;
            line-height: 34px;
            background: #f5f6f9;
            border: 1px solid rgba(30, 31, 36, .06);
            border-radius: 4px;
            padding: 0 14px;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #848693;
            font-weight: 400;
            cursor: pointer;

            &:not(:first-child) {
                margin-left: 14px;
            }

            &.active {
                font-family: PingFangSC-Semibold;
                color: #05f;
                font-weight: 600;
                background: rgba(0, 85, 255, .07);
                border: 1px solid rgba(0, 85, 255, .08);
            }
        }
    }

    .info {
        padding-bottom: 30px;
    }

    .info-content {
        .item {
            display: flex;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            line-height: 14px;
            font-weight: 400;

            &:not(:first-child) {
                margin-top: 18px;
            }

            .label {
                color: #848691;
                margin-right: 26px;
                min-width: 56px;
                line-height: 22px;
            }

            .value {
                color: #1e1f24;
                line-height: 22px;

                &.avatar img {
                    border-radius: 6px;
                    border: 1px solid #f5f6f9;
                }

                &.isNull {
                    color: #b7b9c1;
                }

                img {
                    height: 80px;
                    width: 80px;

                    &:not(:first-child) {
                        margin-left: 14px;
                    }
                }
            }

            .tips {
                color: #ff5353;
                margin-left: 18px;
                line-height: 22px;

                .btn {
                    color: #05f;
                    cursor: pointer;
                }
            }

            .domain {
                display: flex;
                font-family: PingFangSC-Medium;
                font-size: 12px;
                color: #737d99;
                letter-spacing: 0;
                line-height: 12px;
                font-weight: 500;
                height: 22px;

                .domain-item {
                    padding: 4px 6px;
                    border: 1px solid rgba(115, 125, 153, .4);
                    border-radius: 4px;

                    &:not(:first-child) {
                        margin-left: 8px;
                    }
                }
            }
        }
    }

    .promotional-images {
        display: flex;
        width: 100%;
        height: 177px;
        background-position: center center;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        border-radius: 8px;

        /deep/.lawyer-info {
            margin-left: 21px;
            color: #fff;

            .row {
                display: flex;
                line-height: 1;
                align-items: flex-end;
                width: 320px;
                white-space: nowrap;

                .law-firm,
                .domain {
                    .text-overflow-ellipsis(1);
                }

                &:not(:first-child) {
                    margin-top: 13px;
                }

                &:first-child {
                    margin-top: 24px;
                }

                .name {
                    font-size: 21px;
                }

                .job {
                    font-size: 14px;
                    margin-left: 4px;
                }

                .domain {
                    font-size: 8px;
                }

                .phone {
                    height: 20px;
                    padding: 0 10px;
                    color: #422b16;
                    font-size: 8px;
                    line-height: 20px;
                    text-align: center;
                    background: linear-gradient(90deg, #fcda8f, #ffedb3);
                    border-radius: 2px;
                }
            }
        }
    }

    .title {
        display: flex;
        align-items: center;
        position: relative;
        margin-bottom: 24px;

        .title-name {
            font-family: PingFangSC-Semibold;
            font-size: 16px;
            color: #1e1f24;
            line-height: 16px;
            font-weight: 600;
        }

        .status-text {
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #00cc63;
            letter-spacing: 0;
            text-align: center;
            line-height: 12px;
            font-weight: 400;
            margin-left: 12px;

            &.error {
                color: #ec4532;
            }

            &.warning {
                color: rgb(248, 167, 67);
            }
        }

        .modify-btn {
            position: absolute;
            font-family: PingFangSC-Regular;
            font-size: 16px;
            color: #05f;
            letter-spacing: 0;
            line-height: 20px;
            font-weight: 400;
            float: right;
            padding-right: 22px;
            right: 0;
            height: 20px;
            cursor: pointer;

            &::after {
                content: "";
                height: 20px;
                width: 20px;
                display: inline-block;
                position: absolute;
                top: 1px;
                background: url("https://lvlin-base.cdn.bcebos.com/fe-saas/page/personal-info/arrow.png") no-repeat center center / 100%;
            }
        }
    }

    .not-vip-content {
        border: 1px solid rgba(245, 246, 249, 1);
        border-radius: 8px;
        padding: 18px;
        background: url("https://lvlin-base.cdn.bcebos.com/fe-saas/page/personal-info/not-vip-bg.png") no-repeat top center / 100% 85px;

        .not-vip-title {
            width: 448px;
            height: 14px;
            font-family: PingFangSC-Medium;
            font-size: 14px;
            color: #7f3c00;
            line-height: 14px;
            font-weight: 500;
        }

        .pic-tips,
        .case-tips {
            margin: 15px 0;
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #848691;
            line-height: 12px;
            font-weight: 400;
            padding-left: 20px;
            position: relative;

            &::before {
                content: "";
                height: 14px;
                width: 14px;
                display: inline-block;
                position: absolute;
                top: -1px;
                left: 0;
                background: url("https://lvlin-base.cdn.bcebos.com/fe-saas/page/personal-info/vip-icon.png") no-repeat center center / 100%;
            }
        }

        .case-box {
            width: 100%;
            display: flex;
            justify-content: space-between;

            .case-item {
                height: 100%;
                width: 250px;
            }
        }

        .case-tips {
            margin-top: 19px;
        }
    }

    .line {
        width: 100%;
        height: 1px;
        margin-bottom: 30px;
        background: #e9ecf3;
    }

    .case-box.real {
        display: grid;
        grid-template-columns: 260px 260px 260px;
        grid-column-gap: 24px;
        grid-template-rows: auto;
        height: 150px;
    }
}
</style>
